// src/services/DoorService.js
//
// Doors and the office each one belongs to.
//
// This is the one piece of location data Vero genuinely owns. Entra knows about
// offices but nothing about the hardware on a wall, and the door controller
// knows about hardware but nothing about Entra. The mapping between them lives
// here and nowhere else.

import apiClient from './apiClient'

export async function getDoors() {
  const response = await apiClient.post('/GetDoors', {})

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not read doors')
  }
  return response.data.doors ?? []
}

export async function setDoor({ doorUuid, countryCode, officeName, doorLabel }) {
  const response = await apiClient.post('/SetDoor', {
    door_uuid: doorUuid,
    country_code: countryCode,
    office_name: officeName,
    door_label: doorLabel ?? ''
  })

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not save the door')
  }
}

export async function deleteDoor(doorUuid) {
  const response = await apiClient.post('/DeleteDoor', { door_uuid: doorUuid })

  if (response.data?.status !== 'success') {
    throw new Error(response.data?.message ?? 'Could not delete the door')
  }
}
